import { useState } from "react";
import usePut from "../usePut";
import toast from "react-hot-toast";

const useDeleteAttendanceRow = ({ refetchAttendanceList }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [attendanceRow, setAttendanceRow] = useState(null);

  const { handleAuth } = usePut({
    url: "deleteAttendance",
    method: "DELETE",
    onSuccess: () => {
      setShowDeleteModal(false);
      refetchAttendanceList(); // Refetch the attendance list after deletion
      // Optionally, you can add a success notification here
      toast.success("Attendance record deleted successfully");
    },
    onError: (error) => {
      // Optionally, you can add an error notification here
      toast.error("Failed to delete attendance record: " + error.message);
    },
  });

  const toggleDeleteModal = (row) => {
    setAttendanceRow(row);
    setShowDeleteModal((prev) => !prev);
  };

  const handleDeleteAttendance = () => {
    if (attendanceRow) {
      handleAuth.mutate({ id: attendanceRow.id });
    }
  };

  return {
    showDeleteModal,
    attendanceRow,
    toggleDeleteModal,
    handleDeleteAttendance,
    isDeleting: handleAuth.isLoading, // To show loading state in the modal
  };
};

export default useDeleteAttendanceRow;
